import { Tile } from '../tile'
import { API } from "./api"

const dir = "https://raw.githubusercontent.com/FluffyStuff/riichi-mahjong-tiles/master/Regular/"
const ext = ".svg"
const baseName = ({kind, rank}: Tile) =>
{
    switch (kind)
    {
        case "w":
            return `Man${rank}`
        case "t":
            return `Sou${rank}`
        case "b":
            return `Pin${rank}`
        case "f":
            return {
                1: "Ton",
                2: "Nan",
                3: "Shaa",
                4: "Pei",
            }[rank as 1|2|3|4]
        case "j":
            return {
                1: "Chun",
                2: "Hatsu",
                3: "Haku",
            }[rank as 1|2|3]
    }
}
const fluffystuff: API = {dir, ext, baseName}
export default fluffystuff
